<!--生产制造-基础数据-下单检查项维护-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="maintenance-search-form" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <a-range-picker slot="createTime" v-model="queryParams.createTime" valueFormat="YYYY-MM-DD" allowClear />
        <a-select slot="firstPieceState" v-model="queryParams.firstPieceState" allowClear>
          <a-select-option :value="'1'">是</a-select-option>
          <a-select-option :value="'0'">否</a-select-option>
        </a-select>
        <a-select slot="firstFivePieceState" v-model="queryParams.firstFivePieceState" allowClear>
          <a-select-option :value="'1'">是</a-select-option>
          <a-select-option :value="'0'">否</a-select-option>
        </a-select>
        <a-select slot="bigGoodsEvaluationState" v-model="queryParams.bigGoodsEvaluationState" allowClear>
          <a-select-option :value="'1'">是</a-select-option>
          <a-select-option :value="'0'">否</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['mes:orderInspectionMaintenance:add']" @click="handleAdd">新增</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mes:orderInspectionMaintenance:import']" @click="handleImport">导入</a-button>
        <download-modal :apiFun="apiScpOrderCheckItemExport" ref="download" />
        <a-button type="primary" :loading="loading" v-hasPermi="['mes:orderInspectionMaintenance:export']" @click="handleExport">导出</a-button>
        <add-maintenance ref="addMaintenanceRef" @refreshFun="handleOk" />
        <import-excel
          ref="importExcelRef"
          :downloadParams="downloadParams"
          :uploadParams="upload"
          :customizeUpload="true"
          :uploadAboutRequest="uploadAboutRequest"
          @refresh="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          @successCallBack="successCallBack"
          :scroll="{ fixScreen: true, x: 1500 }">
          <template slot="dateFormat2" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!--首件是否通过-->
          <template slot="firstPieceState" slot-scope="{ text, record }">
            <span v-if="!isEdit || currentId !== record.id">{{ text ? (text === '1' ? '是' : '否') : '' }}</span>
            <a-select style="width: 100%" v-else v-model="record.firstPieceState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </template>
          <!--首5件是否通过-->
          <template slot="firstFivePieceState" slot-scope="{ text, record }">
            <span v-if="!isEdit || currentId !== record.id">{{ text ? (text === '1' ? '是' : '否') : '' }}</span>
            <a-select style="width: 100%" v-else v-model="record.firstFivePieceState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </template>
          <!--大货改善评估是否通过-->
          <template slot="bigGoodsEvaluationState" slot-scope="{ text, record }">
            <span v-if="!isEdit || currentId !== record.id">{{ text ? (text === '1' ? '是' : '否') : '' }}</span>
            <a-select style="width: 100%" v-else v-model="record.bigGoodsEvaluationState" allowClear>
              <a-select-option :value="'1'">是</a-select-option>
              <a-select-option :value="'0'">否</a-select-option>
            </a-select>
          </template>
          <!--备注-->
          <template slot="remark" slot-scope="text">
            <a-tooltip placement="topLeft" v-if="!isEdit || currentId !== text.record.id">
              <template slot="title">
                <span>{{ text.record.remark }}</span>
              </template>
              <span>{{ text.record.remark }}</span>
            </a-tooltip>
            <a-input v-else type="text" v-model="text.record.remark" :maxLength="200" />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" v-hasPermi="['mes:orderInspectionMaintenance:edit']" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
            <a class="ml10" v-hasPermi="['mes:orderInspectionMaintenance:delete']" @click="handleDel(text.record)">删除</a>
            <a class="ml10" @click="handleLog(text.record)">日志</a>
          </span>
        </ls-api-table>
      </div>
      <BatchEditModal ref="BatchEditModalRef" @refreshFun="handleOk" />
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import BatchEditModal from '@/views/scp/producingAndMarketing/furniture-placement-demand/demand/components/batch-edit-modal.vue'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import addMaintenance from '@/views/mes/basedata/order-inspection-maintenance/components/add-maintenance.vue'
import ImportExcel from "@/views/finished-goods-order/base-data/supplier-process-ranking/components/importExcel"
import {
  apiGetCheckItemLog,
  apiScpOrderCheckItemDel,
  apiScpOrderCheckItemList,
  apiScpOrderCheckItemUpdate,
  apiScpOrderCheckItemExport
} from '@/api/mes/basedata/orderInspectionMaintenance'
import { METHOD, requestSet } from '@/utils/request'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  name: 'OrderInspectionMaintenance',
  components: { DownloadModal, BatchEditModal, OperationLogModel, addMaintenance, ImportExcel },
  mixins: [cacheSearch],
  data() {
    return {
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpOrderCheckItem/template' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/scpOrderCheckItem/template',
        name: `下单检查项维护导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      uploadAboutRequest: {
        requestApi: '',
        errFileName: '下单检查项维护导入异常.xlsx'
      },
      loading: false,
      versionSelectList: [], // 版本号下拉选择框
      isEdit: false,
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      currentId: "",
      apiScpOrderCheckItemExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpOrderCheckItemList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        vendorCode: undefined,
        vendorName: undefined,
        itemCode: undefined,
        itemName: undefined,
        createTime: undefined,
        stareCreateDate: undefined,
        endCreateDate: undefined,
        firstPieceState: '1',
        firstFivePieceState: undefined,
        bigGoodsEvaluationState: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '供应商编码', decorator: ['vendorCode'], type: 'input' },
        { label: '供应商名称', decorator: ['vendorName'], type: 'input' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        { label: '物料名称', decorator: ['itemName'], type: 'input' },
        {
          label: '创建时间',
          type: 'range',
          decorator: ['createTime'],
          disposeFormat: {
            stareCreateDate: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endCreateDate: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '首件是否通过', decorator: ['firstPieceState'], type: 'firstPieceState' },
        { label: '首5件是否通过', decorator: ['firstFivePieceState'], type: 'firstFivePieceState' },
        { label: '大货改善评估是否通过', decorator: ['bigGoodsEvaluationState'], type: 'bigGoodsEvaluationState' }
      ],
      // 表格字段
      columns: [
        { title: '供应商编码', dataIndex: 'vendorCode', align: 'center', width: 120 },
        { title: '供应商名称', dataIndex: 'vendorName', align: 'center', width: 150 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 150 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 120, ellipsis: true },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 160, ellipsis: true },
        {
          title: '首件是否通过',
          dataIndex: 'firstPieceState',
          align: 'center',
          scopedSlots: { customRender: 'firstPieceState' },
          width: 100
        },
        {
          title: '首5件是否通过',
          dataIndex: 'firstFivePieceState',
          align: 'center',
          scopedSlots: { customRender: 'firstFivePieceState' },
          width: 100
        },
        {
          title: '大货改善评估是否通过',
          dataIndex: 'bigGoodsEvaluationState',
          scopedSlots: { customRender: 'bigGoodsEvaluationState' },
          align: 'center',
          width: 100
        },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          align: 'center',
          width: 200,
          ellipsis: true
        },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 90 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 150 },
        { title: '最后修改时间', dataIndex: 'updateTime', align: 'center', width: 150 },
        { title: '最后修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        {
          title: '操作',
          width: 160,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        '',
        {
          createTime: ['stareCreateDate', 'endCreateDate']
        }
      )
    }
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 导入
    handleImport () {
      // 导入请求，带参数
      const apiImportPlanOrder = (params) => {
        return requestSet(`/scp/scpOrderCheckItem/import`, METHOD.POST, params, { responseType: "blob" });
      }
      this.uploadAboutRequest.requestApi = apiImportPlanOrder;
      this.$refs.importExcelRef.show()
    },
    // 删除
    handleDel(row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `确定删除该数据吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpOrderCheckItemDel(row.id).then(res => {
            if (res.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(res?.msg || '删除失败')
            }
          })
        }
      })
    },
    // 新增
    handleAdd() {
      this.$refs.addMaintenanceRef.show()
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetCheckItemLog({ checkItemId: row.id }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 翻页清除选择
    successCallBack() {
      this.isEdit = false
      this.currentId = '';
      if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      this.loading = true;
      apiScpOrderCheckItemUpdate(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.currentId = ''
          this.isEdit = false;
          this.handleEditRefresh()
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 取消
    handleCancel() {
      this.handleEditRefresh();
    },
    // 表单搜索, changePage: 是否切换页码，默认为false, true为不切换页面（不返回首页）
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 新增/修改框事件
    handleEditRefresh() {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, true)
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        vendorCode: undefined,
        vendorName: undefined,
        itemCode: undefined,
        itemName: undefined,
        createTime: undefined,
        stareCreateDate: undefined,
        endCreateDate: undefined,
        firstPieceState: undefined,
        firstFivePieceState: undefined,
        bigGoodsEvaluationState: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.maintenance-search-form .ant-col:nth-last-child(2) {
  .ant-form-item{
    .ant-form-item-label{
      width: 200px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 190px !important;
    }
  }
}
</style>
